<template>
    <div>
      <div :class="onlinestate == 'pc' ?'fourlist':'fourlistphone'" style="display:flex">
        <div class="fourlistphone_div" style="borderRight:1px solid #d8d8d8;" :style="{fontSize : onlinestate=='pc' ?'18px':'17px'}">{{$lang.jjfw}}</div>
        <div class="phone_class" style="padding: 0;display:flex">
          <div class="fourlistphone_div" v-for='(v,i) in list' :key='i+"101"' :style="{borderRight:(i+1)<list.length?'1px solid #d8d8d8':''}" @click='handclick(i)'>
            <span :style="{borderBottom:isright==i?'3px solid #09666E':''}">{{v}}</span>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
  export default{
    props:['isnum'],
    data(){
      return{
        onlinestate:sessionStorage['onlinestate'],
        islang : window.localStorage.guanwanglang,
        list:[this.$lang.jjjs,this.$lang.jjcp],//'債券服務',
        urllist:['/fund_introduction','/fund_products'],  //'/bonds_introduction',
        isright:1
      }
    },
    watch:{
      isnum:{
        immediate:true,
        handler(ev){
          this.isright = this.isnum
        }
      }
    },
    methods:{
      handclick(i){
        this.isright = i
        if(this.urllist[i]){
          this.$router.push(this.urllist[i])
        }
      }
    }
  }
</script>

<style scoped>
  .fourlist{
    /* display: flex;
    justify-content: space-between; */
    font-size: 16px;
    margin-bottom: 2rem;
    margin-left: -1rem;
  }
  .fourlist div{
    display: inline-block;
    padding: 0 1rem;
    font-size: 16px;
    color: #000;
    cursor: pointer;
  }
  .fourlistphone{
    display: flex;
    /* justify-content: space-between; */
    font-size: 16px;
    margin-left: -1rem;
    white-space: pre;
  }
  .fourlistphone .fourlistphone_div{
    display: inline-block;
    padding: 0 1rem;
    font-size: 16px;
    color: #000;
    cursor: pointer;
  }
  .fourlistphone .phone_class{
    overflow-x: auto;
  }
</style>



// WEBPACK FOOTER //
// src/pages/bondfund/compoents/fourlist.vue